

















import { Component, Ref, Vue } from 'vue-property-decorator';
import AppBar from '@/components/core/AppBar.vue';
import Content from '@/components/core/Content.vue';
import Footer from '@/components/core/Footer.vue';
import BackToTop from '@/components/core/BackToTop.vue';
import UnsubscribeTemplate from '@/components/core/UnsubscribeTemplate.vue';
import SkipLink from '@/components/core/SkipLink.vue';
import { NotificationService } from '@/services/notification-services';
import Swal from 'sweetalert2';
import { jwtDecode } from 'jwt-decode';

@Component({
  components: {
    BackToTop,
    UnsubscribeTemplate,
    AppBar,
    Content,
    Footer,
    SkipLink
  }
})
export default class Index extends Vue {
  $route!: any;
  unsubscribeEmail = 'dev@planbook.com'
  unsubscribeType = 'Notifications'
  notificationSettings: any = {};

  @Ref() unsubscribeComponent!: Vue;

  mounted() {
    const hostname = window.location.hostname;
    let url = new URL('https://app.planbook.com');

    if (hostname === 'test-welcome.planbook.com') {
      url = new URL('https://test-app.planbook.com');
    } else if (hostname === 'staging-welcome.planbook.com') {
      url = new URL('https://staging-app.planbook.com');
    } else if (hostname === 'localhost') {
      url = new URL('http://localhost:8090');
    } else if (hostname.endsWith('planbookbeta.com')) {
      url = new URL('https://app.planbookbeta.com');
    }

    const currentUrl = new URL(window.location.href);
    const params = currentUrl.searchParams;

    url.search = params.toString();

    const queryParams = this.$route.query;
    if (queryParams.j || queryParams.sc || queryParams.v || queryParams.p || queryParams.r) {
      window.location.href = url.href;
    }

    if (this.$route.query.n) {
      const manageNotificationsElement = document.getElementById('manageNotifications');
      if (manageNotificationsElement) {
        const manageNotificationContainer = document.getElementById('manageNotificationContainer');
        if (manageNotificationContainer) {
          manageNotificationContainer.style.display = 'none';
        }
        // Set values for the email and notification type
        // SAMPLE VALUES
        // this.notificationSettings = {
        //   email: 'sample-test@planbook.com',
        //   type: 'Account Status Notifications',
        //   sendEmail: false,
        //   sendEmail2: true,
        //   sendEmail3: false,
        //   sendEmail4: false,
        //   sendEmail5: true,
        //   sendEmail6: true,
        //   sendEmail7: true,
        //   sendEmail8: true
        // };
        // this.unsubscribeEmail = 'sample-test@planbook.com'
        // this.unsubscribeType = 'Account Status Notifications';
        // END SAMPLE VALUES

        const rd = jwtDecode(this.$route.query.n as string)
        let nd: any;
        if (rd && rd.sub) {
          nd = JSON.parse(rd.sub);

          // Get the title of notification type
          const checkField = document.querySelector('#manageNotificationContainer .sendEmail' + nd.type);
          if (checkField) {
            this.unsubscribeType = checkField.getAttribute('title') || 'Notifications';
          }

          // If user is an administrator hide Plans Reviewed by Administrator option
          if (nd.userMode === 'A') {
            const sendEmail8 = document.querySelector('#manageNotificationContainer .sendEmail' + nd.type) as HTMLElement;
            if (sendEmail8) {
              sendEmail8.style.display = 'none';
            }
          }

          this.notificationSettings = nd;
          this.unsubscribeEmail = nd.email;
        }

        const content = this.unsubscribeComponent.$el as HTMLElement;
        Swal.fire({
          title: 'Unsubscribe Complete!',
          html: content,
          icon: 'success',
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Close',
          confirmButtonText: 'Update'
        }).then(async (result) => {
          // User updates their notification preferences
          // Based on checklist
          console.log(result);
          if (result.isConfirmed) {
            const request = {
              apiKey: '2e6c6353-3891-4e8a-b579-f6ef074dea34',
              token: this.$route.query.n,
              ...this.notificationSettings
            };

            try {
              await NotificationService.manageNotifications(request);
              Swal.fire({
                title: 'Notification Settings Updated!',
                icon: 'success'
              });
            } catch (err) {
              Swal.fire({
                title: 'Error Updating Notification Settings!',
                icon: 'error'
              })
            }
          }
        });

        manageNotificationsElement.addEventListener('click', () => {
          const notificationContainer = document.getElementById('notificationContainer');
          const swalConfirm = document.getElementsByClassName('swal2-confirm');
          const swalIcon = document.getElementsByClassName('swal2-icon');
          const swalTitle = document.getElementById('swal2-title');
          if (notificationContainer !== null && swalConfirm.length > 0 && swalIcon.length > 0 && swalTitle !== null && manageNotificationContainer !== null) {
            notificationContainer.style.display = 'none';
            (swalConfirm[0] as HTMLElement).style.display = 'block';
            (swalIcon[0] as HTMLElement).style.display = 'none';
            swalTitle.innerHTML = 'Manage Notifications';
            manageNotificationContainer.style.display = 'block';
          }
        });
      }
    } else {
      (this.unsubscribeComponent.$el as HTMLElement).style.display = 'none';
    }
  }
}
